import Vue from 'vue'
import VueRouter from 'vue-router'
import homeRoutes from './home'
import communityRoutes from './community'
import shopRoutes from './shop'
import userRoutes from './user'
import yunRoutes from './yun'
import commonRoutes from './common'
import daySigninRoutes from './daySignin'
import sharePage from './sharePage'
import complaint from './complaint'
import store from '@/store'
import activity from './activity'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/pages/index/index'
  },
  ...homeRoutes,
  ...communityRoutes,
  ...shopRoutes,
  ...userRoutes,
  ...yunRoutes,
  ...commonRoutes,
  ...daySigninRoutes,
  ...complaint,
  ...activity,
  // ...sharePage,

]
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果存在保存的位置信息，则返回之前的位置
      return {
        ...savedPosition,
        behavior: 'instant'
      }
    } else {
      // 其他情况返回顶部
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.logged
  if(to.meta.isLogin && !isLoggedIn){
    store.commit('popup/setloginpop', true)
    next(false)
  } else {
    next()
  }
})

export default router
